import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';
import { JsonParseError } from 'libs/end-to-end/src/types/errors/json-parse-error';
import { z } from 'zod';
import { HttpRequestFailedError } from 'libs/end-to-end/src/types/errors/http-request-failed-error';

export const HttpRequestError = z.union([
  HttpRequestFailedError,
  JsonParseError,
  UnknownError,
]);

export type HttpRequestError = z.infer<typeof HttpRequestError>;
